import data from "./config.json";

const val = data[window.location.host];


(() => {
  if (val) {
    return import(`./assets/scss/wallet-customer/theme/${val.theme}.scss`);
  } else {
    return import(`./assets/scss/wallet-customer/theme/default.scss`);
  }
})();


console.log(val.theme,"theme");